import CreateCVPage from "pages/users/employee/createCVPage";
import{ memo } from "react";

const HomeCreateCVPage = () =>{
    return (
        <CreateCVPage/>
    );
}

export default memo(HomeCreateCVPage);